import ObjectBlocker from "./ObjectBlocker";
import { ObjectSuperTypesEnum, SelectionTypeEnum, Icons } from "../../enums";
import { getSvgObject } from "../../utils/ObjectUtil";

class Seat extends ObjectBlocker {
  protected getIconSize(seat: any): number {
    return seat.item(0).radius * 1.7;
  }

  protected getHoverRadius(seat: any): number {
    return seat.item(0).radius;
  }

  protected getSelectionTargets(group: any): any[] {
    const isRow = group.superType === ObjectSuperTypesEnum.Row;
    const isTable = group.superType === ObjectSuperTypesEnum.RoundTable || group.superType === ObjectSuperTypesEnum.RectTable;
    if (!isRow && !(isTable && group.selectionType !== SelectionTypeEnum.byTable)) return [];
    return (group.getObjects("group") || []).filter((object: any) => object.superType === ObjectSuperTypesEnum.Seat);
  }

  protected hasSpecialIcon(seat: any): boolean {
    return !!(seat.accesible || seat.companion || seat.restrictedView);
  }

  protected restoreSpecialIcon(seat: any): void {
    const icon = seat.restrictedView ? Icons.restricted : seat.accesible ? Icons.accesible : Icons.companion;
    seat.insertAt(getSvgObject(icon, this.getIconSize(seat), "#000000"), 2, true);
  }
}

export default Seat;
